var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"headers"},[_c('div',{staticClass:"headers-nav"},[_c('gradationText',{attrs:{"text":"宝智达冷链-智慧环境管理系统","size":"200%"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }